export class BaseDataEvent
{
    static VALUE_CHANGED: string = "BaseDataEvent.VALUE_CHANGED";
    static DELETED: string = "BaseDataEvent.DELETED";

}
